module.exports = __webpack_public_path__ + "static/media/catat_pelanggaran.bf628fbb.png";